import { OTPInput, OTPInputContext, OTPInputProps } from 'input-otp'
import * as React from 'react'

import { referralCodeLength } from '@/features/points/consts'
import { cn } from '@/ui/utils/style'
import { testIds } from '@/ui/utils/testIds'

interface ReferralInputProps extends Pick<OTPInputProps, 'value' | 'onChange'> {
  disabled?: boolean
  initialValue?: string
  className?: string
  error?: string
}

export function ReferralInput({ disabled, value, onChange, initialValue, error, className }: ReferralInputProps) {
  const isError = !!error

  return (
    <OTPInput
      maxLength={referralCodeLength}
      containerClassName={cn('flex items-center pb-5 has-disabled:opacity-50', isError && 'pb-0', className)}
      className="disabled:cursor-not-allowed"
      disabled={disabled}
      value={value}
      onChange={onChange}
      defaultValue={initialValue}
      data-testid={testIds.points.referralInput.input}
    >
      <div className="flex flex-col gap-1">
        <div className="flex items-center gap-3">
          <ReferralSlot index={0} isError={isError} />
          <ReferralSlot index={1} isError={isError} />
          <ReferralSlot index={2} isError={isError} />
          <ReferralSlot index={3} isError={isError} />
          <ReferralSlot index={4} isError={isError} />
          <ReferralSlot index={5} isError={isError} />
        </div>
        {isError && (
          <div
            className="typography-label-4 text-system-error-primary"
            data-testid={testIds.points.referralInput.error}
          >
            {error}
          </div>
        )}
      </div>
    </OTPInput>
  )
}

export function ReferralSlot({ index, isError }: { index: number; isError: boolean }) {
  const inputOTPContext = React.useContext(OTPInputContext)
  const { char, hasFakeCaret, isActive } = inputOTPContext.slots[index]!

  return (
    <div
      className={cn(
        'typography-heading-4 relative flex h-10 w-8 items-center justify-center rounded-md md:h-[72px] md:w-16',
        'border border-fg-secondary text-primary-inverse shadow-xs transition-all',
        isError && 'border-transparent ring-1 ring-error-700',
        isActive && 'border-brand-tertiary',
      )}
    >
      {char}
      {hasFakeCaret && (
        <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
          <div className="h-5 w-px animate-caret-blink bg-primary duration-1000" />
        </div>
      )}
    </div>
  )
}
